import React from 'react';
import PropTypes from 'prop-types';
import SinglePicker from '../common/controls/singlePicker';
const FormFormFilter = ({
  selectedForms,
  forms,
  label,
  onFilter,
  onSearch
}) => /*#__PURE__*/React.createElement(SinglePicker, {
  label: label,
  value: selectedForms === null || selectedForms === void 0 ? void 0 : selectedForms[0],
  options: forms,
  onTextChange: onSearch,
  onChange: value => onFilter('formForm', [value])
});
FormFormFilter.propTypes = {
  forms: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    label: PropTypes.string,
    name: PropTypes.string,
    value: PropTypes.string,
    className: PropTypes.string
  })).isRequired,
  selectedForms: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    label: PropTypes.string,
    name: PropTypes.string,
    value: PropTypes.string,
    className: PropTypes.string
  })).isRequired,
  onFilter: PropTypes.func.isRequired,
  onSearch: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired
};
export default FormFormFilter;